<template>
<div class="chapter">
<div class="inner_page">
<article epub:type="frontmatter">
<div class="bodymatter" epub:type="bodymatter">
<section epub:type="division" id="toc">
<h1 class="toc"><a id="pagev"></a>CONTENTS</h1>
<p class="toc_chap01"><a class="hlink" href="#/Text/9781454934721_itr"><span class="brown">INTRODUCTION</span></a></p>
<p class="toc_chap"><a class="hlink" href="#/Text/9781454934721_p01"><span class="sans">PART ONE</span><br/><span class="big3"><span class="brown">DETROIT</span></span></a></p>
<p class="toc_chap"><span class="hlink" href="#/Text/9781454934721_p02" title="Link target outside of Sample"><span class="sans">PART TWO</span><br/><span class="big3"><span class="brown">REINVENTION</span></span></span></p>
<p class="toc_chap"><span class="hlink" href="#/Text/9781454934721_p03" title="Link target outside of Sample"><span class="sans">PART THREE</span><br/><span class="big3"><span class="brown">DIVA</span></span></span></p>
<p class="toc_chap"><span class="hlink" href="#/Text/9781454934721_p04" title="Link target outside of Sample"><span class="sans">PART FOUR</span><br/><span class="big3"><span class="brown">HONORS &amp; AWARDS</span></span></span></p>
<p class="toc_chap"><span class="hlink" href="#/Text/9781454934721_p05" title="Link target outside of Sample"><span class="sans">CODA</span><br/><span class="big3"><span class="brown">PAYING THEIR R-E-S-P-E-C-T</span></span></span></p>
<p class="toc_chap11"><span class="hlink" href="#/Text/9781454934721_bm1" title="Link target outside of Sample">Selected Discography</span></p>
<p class="toc_chap1"><span class="hlink" href="#/Text/9781454934721_ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc_chap1"><span class="hlink" href="#/Text/9781454934721_nts" title="Link target outside of Sample">Notes</span></p>
<p class="toc_chap1"><span class="hlink" href="#/Text/9781454934721_pcr" title="Link target outside of Sample">Picture Credits</span></p>
<p class="toc_chap1"><span class="hlink" href="#/Text/9781454934721_ata" title="Link target outside of Sample">About the Author</span></p>
</section>
</div>
</article>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781454934721_toc.vue?23b096bc